import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "admin-login" }
const _hoisted_2 = { class: "login-container" }
const _hoisted_3 = { class: "login-form" }
const _hoisted_4 = { class: "login-header" }
const _hoisted_5 = { class: "logo" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "links" }

import { ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { User, Lock, Management } from '@element-plus/icons-vue';
import { adminLogin } from '@/admin/api/auth';


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminLoginView',
  setup(__props) {

const router = useRouter();

const loginFormRef = ref();
const loading = ref(false);
const rememberMe = ref(false);

const loginForm = reactive({
  username: '',
  password: ''
});

const loginRules = {
  username: [
    { required: true, message: '请输入用户名', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' },
    { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
  ]
};

const submitForm = async () => {
  try {
    await loginFormRef.value.validate();
    loading.value = true;
    
    const response = await adminLogin(loginForm.username, loginForm.password);
    
    if (response.code === 1) {
      // 存储token和用户信息
      localStorage.setItem('adminToken', response.data.token);
      localStorage.setItem('adminUserInfo', JSON.stringify(response.data.userInfo));
      localStorage.setItem('adminMenus', JSON.stringify(response.data.menus));
      
      ElMessage.success('登录成功');
      // 跳转到管理后台首页
      router.push('/admin/dashboard');
    } else {
      ElMessage.error(response.msg || '登录失败');
    }
  } catch (error) {
    console.error('Login error:', error);
    ElMessage.error('登录失败，请检查用户名和密码');
  } finally {
    loading.value = false;
  }
};

const goToHome = () => {
  router.push('/');
};

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_icon, { class: "logo-icon" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Management))
              ]),
              _: 1
            }),
            _cache[3] || (_cache[3] = _createElementVNode("h2", null, "管理后台", -1))
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("p", null, "请输入管理员账号和密码", -1))
        ]),
        _createVNode(_component_el_form, {
          model: loginForm,
          rules: loginRules,
          ref_key: "loginFormRef",
          ref: loginFormRef,
          onKeyup: _withKeys(submitForm, ["enter"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { prop: "username" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: loginForm.username,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginForm.username) = $event)),
                  placeholder: "用户名",
                  "prefix-icon": _unref(User),
                  size: "large"
                }, null, 8, ["modelValue", "prefix-icon"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "password" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: loginForm.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginForm.password) = $event)),
                  type: "password",
                  placeholder: "密码",
                  "prefix-icon": _unref(Lock),
                  size: "large",
                  "show-password": ""
                }, null, 8, ["modelValue", "prefix-icon"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_checkbox, {
              modelValue: rememberMe.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((rememberMe).value = $event)),
              style: {"margin-bottom":"20px"}
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("记住我", -1)
              ]))]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: submitForm,
                  loading: loading.value,
                  size: "large",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (!loading.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, "登录"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_7, "登录中..."))
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_link, {
            onClick: goToHome,
            type: "primary",
            underline: false
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("返回首页", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_link, {
            href: "#",
            type: "primary",
            underline: false
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("忘记密码？", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})